import React from "react";
import '../assets/css/SecurityPage.css'
import Security_version from '../assets/images/Security Page images/We Take Security Very Seriously.svg';
import Manage_cloud from '../assets/images/Security Page images/Our Security Measures/Fully Managed Cloud Environment.svg';
import Backup_image from '../assets/images/Security Page images/Our Security Measures/Dedicated Computing for Backup & Restore.svg';
import Encription_image from '../assets/images/Security Page images/Our Security Measures/Encryption at Rest and in Transit.svg';
import Data_region_image from '../assets/images/Security Page images/Our Security Measures/User-Defined Data Regions.svg';
import Multi_factor_image from '../assets/images/Security Page images/Our Security Measures/Multi-Factor Authentication (MFA).svg';
import EnableMFA_image from '../assets/images/Security Page images/Recommended Best Practices/Enable MFA.jpg';
import Seperate_api_image from '../assets/images/Security Page images/Recommended Best Practices/Use Separate API Keys for Backup and Restoration.jpg';
import Rotate_api_image from '../assets/images/Security Page images/Recommended Best Practices/Rotate API Keys Regularly.jpg';
const SecurityPage = () => {
  return (
    <>
    <div className="container first-section-main">
      <h1 className="text-center">Security</h1>
      {/* ----------------first section---------------- */}
      <div className="first-security-div container d-flex">
        <div className="  col-md-6 image-div-inner">
          <img src={Security_version} alt="security-image" />
        </div>
        <div className="col-md-6 content-main-div">
          <h2 className="text-center">We Take Security Very Seriously</h2>
          <p className="security-para text-center">
            At BackupMeraki, safeguarding your network data is our highest
            priority. As a fully managed, cloud-hosted service, we adhere to
            stringent security standards at every level.
          </p>
        </div>
      </div>
    </div>
    
      {/* ------------------second section------------- */}
      <section className="second-section">
      <div className="container">
        <div className="headin-second-section">
          <h2 className="text-center">Our Security Measures</h2>
        </div>
        <div className="card-div container ">
        <div className="card-1-2-3 d-flex">
          {/* card 1 */}
          <div className="card-1 card-image">
            <div className="img-card">
              <img src={Manage_cloud} alt="card1" />
            </div>
            <div className="card-content">
              <h4>Fully Managed Cloud Environment</h4>
              <span className="text-center">
                Our platform leverages top-tier cloud infrastructure, which
                undergoes regular security assessments and adheres to leading
                industry certifications. This managed environment allows us to
                scale quickly while maintaining strict security controls.
              </span>
            </div>
          </div>
          {/* card 2 */}
          <div className="card-2 card-image">
            <div className="img-card">
              <img src={Backup_image} alt="card2" />
            </div>
            <div className="card-content">
              <h4 className="text-center">
                Dedicated Computing for Backup & Restore
              </h4>
              <span className="text-center">
                We run each backup and restore process in an isolated computing
                environment. This containerized approach ensures that every task
                is segregated from others, offering robust protection for your
                data and preventing any cross-tenant interference.
              </span>
            </div>
          </div>
          {/* card 3 */}
          <div className="card-3 card-image">
            <div className="img-card">
              <img src={Encription_image} alt="card3" />
            </div>
            <div className="card-content">
              <h4 className="text-center">Encryption at Rest and in Transit</h4>
              <span className="text-center">
                All backup data is encrypted in transit using secure protocols,
                preventing interception while it travels across networks. In
                addition, your data remains encrypted at rest, safeguarding it
                even if the underlying storage media were compromised. Your API
                keys receive the same level of protection: they are never stored
                in plaintext and can only be accessed by authorized processes
                within our platform, ensuring they remain secure at all times.
              </span>
            </div>
          </div>
          </div>
          <div className="card-4-5 d-flex">
          {/* card 4 */}
          <div className="card-4 card-image">
            <div className="img-card">
              <img src={Data_region_image} alt="card4" />
            </div>
            <div className="card-content">
              <h4 className="text-center">User-Defined Data Regions</h4>
              <span className="text-center">
                To comply with local data governance requirements and minimize
                latency, you can choose where your backups are stored. Whether
                you’re based in Europe, the Americas, or the Asia-Pacific
                region, we’ll keep your data in the location that best fits your
                needs.
              </span>
            </div>
          </div>
          {/* card 5 */}
          <div className="card-5 card-image">
            <div className="img-card">
              <img src={Multi_factor_image} alt="card5" />
            </div>
            <div className="card-content">
              <h4 className="text-center">Multi-Factor Authentication (MFA)</h4>
              <span className="text-center">
                Each user account is protected by MFA to add an extra layer of
                security. Even if an unauthorized party gains access to your
                password, they won’t be able to log in without the second
                authentication factor.
              </span>
            </div>
          </div>
          </div>
        </div>
      </div>
      </section>
      {/* ------------------third section last one */}
      <div className="container section-third-last">
        <div className="heading-div-third ">
          <h2 className="text-center">Recommended Best Practices</h2>
        </div>
        <div className="third-section-cards container d-flex">
        {/*  third-section-card-1 */}
          <div className="third-section-card">
            <div className="third-img-div ">
              <img src={EnableMFA_image} alt="third image-1" />
            </div>
            <div className="third-content-div">
              <h4>Enable MFA</h4>
              <p className="text-center">
                MFA is one of the most effective ways to protect against
                unauthorized access. Make sure to enable it for your
                BackupMeraki account.
              </p>
            </div>
          </div>
        {/* third-section-card-2 */}
          <div className="third-section-card">
            <div className="third-img-div ">
              <img src={Seperate_api_image} alt="third image-2" />
            </div>
            <div className="third-content-div">
              <h4>Use Separate API Keys for Backup and Restoration</h4>
              <p className="text-center">
                Whenever possible, use a read-only Meraki account for regular
                backups. This minimizes potential impact if credentials are
                exposed, since no changes can be made with a read-only key. If
                you need to perform a restore, you can temporarily swap in a
                read-write API key to complete the process, then revert to the
                read-only key afterward.
              </p>
            </div>
          </div>
          {/* third-section-card-3  */}
          <div className="third-section-card">
            <div className="third-img-div ">
              <img src={Rotate_api_image} alt="third image-3" />
            </div>
            <div className="third-content-div">
              <h4>Rotate API Keys Regularly</h4>
              <p className="text-center">
                Just like changing passwords periodically, rotating API keys
                limits the risk of compromised credentials. If you suspect your
                key has been exposed, revoke it immediately and generate a new
                one.
              </p>
            </div>
          </div>
        </div>
      </div>
    
    </>
  );
};

export default SecurityPage;
